var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Policies")]),_c('PoliciesMain',{ref:"policiesMain",attrs:{"type":"mortgage"},on:{"refresh":_vm.refreshPolicies},model:{value:(_vm.form.policies_main),callback:function ($$v) {_vm.$set(_vm.form, "policies_main", $$v)},expression:"form.policies_main"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }